import { _dummyMigrateTo1 } from './migrateTo1';
import { _migrateTo2 } from './migrateTo2';
import { _migrateTo3 } from './migrateTo3';
import { _migrateTo4 } from './migrateTo4';
import { _migrateTo5 } from './migrateTo5';
import { _migrateTo6 } from './migrateTo6';
import { _migrateTo7 } from './migrateTo7';
import { _migrateTo8 } from './migrateTo8';
import { LoadedWorkflowV9, _migrateTo9 } from './migrateTo9';
import type { MigrationFn } from './runMigrationChain';

// update the below upon adding each new migration

/** data Visual Builder saves and controls, loaded/saved to `layout.data`. */
export type LoadedWorkflowLatest = LoadedWorkflowV9;

export const _MIGRATION_CHAIN: ReadonlyArray<MigrationFn<any, any>> = [
  _dummyMigrateTo1,
  _migrateTo2,
  _migrateTo3,
  _migrateTo4,
  _migrateTo5,
  _migrateTo6,
  _migrateTo7,
  _migrateTo8,
  _migrateTo9,
  // add new migrations here
] as const;

// ===============================================

export const LATEST_WORKFLOW_MIGRATION_VERSION = _MIGRATION_CHAIN.length;
